import { Icon } from "antd";
import "antd/lib/icon/style";

const VhIconCommon = Icon.createFromIconfontCN({
  // scriptUrl: "//at.alicdn.com/t/font_1137289_4rvvoxbf41.js"
  // scriptUrl: "//at.alicdn.com/t/font_1137289_k0bflay9xv8.js" 2.3.3
  // scriptUrl: "//at.alicdn.com/t/font_1137289_bbbxg23e6.js" 2.3.4
  // scriptUrl: "//at.alicdn.com/t/font_1137289_brwga4fit09.js" 2.3.7
  scriptUrl: "//at.alicdn.com/t/font_1137289_eaexo1v91d.js" 
});

export default VhIconCommon;
